export enum CommunicationLayerPreference {
  SOCKET = 'socket',
}
